import { api } from './nocode';

/**
 * SES PROXY INTEGRATION
 * Bypasses strict browser CORS blocks by routing emails through your PHP proxy.
 */
export const sendEmail = async (to, subject, htmlBody) => {
  try {
    // 1. Fetch settings to get the secure webhook secret
    const res = await api.get('settings_fbwm');
    const settings = Array.isArray(res) ? res : res.data || [];
    const secret = settings.find(s => s.setting_key === 'webhook_secret')?.value || '';

    if (!secret) {
      console.warn("Missing webhook secret. Cannot authenticate with email proxy.");
      return false;
    }

    // 2. Call the PHP proxy script hosted on your external domain
    const proxyRes = await fetch('https://assets.emmausway.co/camp_fbwm/email-sender.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        secret,
        to,
        subject,
        htmlBody
      })
    });

    // 3. Robust Error Logging
    const text = await proxyRes.text();
    try {
      const data = JSON.parse(text);
      if (!data.success) {
         console.error("PHP Proxy or AWS SES Error:", data);
         return false;
      }
      return data.success === true;
    } catch (e) {
      console.error("PHP Proxy returned a non-JSON response. This usually means a PHP fatal error or server misconfiguration:", text);
      return false;
    }
    
  } catch (error) {
    console.error("Error sending email via Proxy:", error);
    return false;
  }
};